import { faCalendarDays as a, faCaretUp as e, faCaretDown as r, faCaretLeft as l, faCaretRight as n, faCreditCard as f, faEnvelope as i, faDollarSign as o, faLock as t, faPhone as c, faMagnifyingGlass as g, faCheck as s, faPen as p, faCircleX as w, faCircleArrowDown as C, faCircleArrowUp as d, faBullhorn as h, faPaperclip as u, faQuestion as m, faBars as D, faBell as A, faPiggyBank as k, faBuildingColumns as L, faSeedling as P, faMinus as B, faArrowLeft as R, faArrowRight as U, faCircleExclamation as y, faAngleUp as b, faAngleDown as x, faAngleLeft as E, faAngleRight as M, faPrint as S, faDownload as X, faMessage as v, faCirclePlus as G, faLocationDot as q, faXmark as I } from "@fortawesome/pro-solid-svg-icons";
const Q = {
  calendar: a,
  caratUp: e,
  caratDown: r,
  caretLeft: l,
  caretRight: n,
  creditCard: f,
  envelope: i,
  dollarSign: o,
  lock: t,
  phone: c,
  magnifyingGlass: g,
  check: s,
  pen: p,
  circleX: w,
  circleArrowDown: C,
  circleArrowUp: d,
  bullhorn: h,
  paperclip: u,
  question: m,
  bars: D,
  bell: A,
  piggyBank: k,
  buildingColumns: L,
  seedling: P,
  minus: B,
  arrowLeft: R,
  arrowRight: U,
  circleExclamation: y,
  angleUp: b,
  angleDown: x,
  angleLeft: E,
  angleRight: M,
  print: S,
  download: X,
  message: v,
  circlePlus: G,
  locationDot: q,
  xmark: I
};
export {
  Q as leftIconOptions
};
